import {
  createWorkOrderSchedule,
  getWorkOrderScheduleById,
  updateWorkOrderSchedule,
  deleteWorkOrderSchedule,
} from '../api/work-order-scheduleAPI';

export function useWorkOrderSchedule() {
  return {
    createSchedule: createWorkOrderSchedule,
    getSchedule: getWorkOrderScheduleById,
    updateSchedule: updateWorkOrderSchedule,
    deleteSchedule: deleteWorkOrderSchedule,
  };
}
